// extracted by mini-css-extract-plugin
export default {"card":"card_card__eVtfe","info":"card_info__16Q6h"};